"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractTableController_1 = require("./AbstractTableController");
var CellEditorProvider_1 = require("./CellEditorProvider");
var CellViewProvider_1 = require("./CellViewProvider");
var configuration_1 = require("./configuration");
var liteEvent_1 = require("./datalayer/liteEvent");
var posterController_1 = require("./datalayer/posterController");
var alwaysUpdateMatrix_1 = require("./grids/matrices/alwaysUpdateMatrix");
var planeditor_1 = require("./planeditor");
var Storage_1 = require("./Storage");
var TotalRowViewProvider_1 = require("./TotalRowViewProvider");
var rowState;
(function (rowState) {
    rowState[rowState["OK"] = 0] = "OK";
    rowState[rowState["Warning"] = 1] = "Warning";
    rowState[rowState["Error"] = 2] = "Error";
    rowState[rowState["ErrorMissed67"] = 3] = "ErrorMissed67";
})(rowState = exports.rowState || (exports.rowState = {}));
;
var RowChangedEvent = (function (_super) {
    __extends(RowChangedEvent, _super);
    function RowChangedEvent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RowChangedEvent.prototype.trigger = function (row, field, value, affectedRow) {
        _super.prototype.fire.call(this, row, field, value, affectedRow);
    };
    return RowChangedEvent;
}(liteEvent_1.LiteEvent));
var ViewChangedEvent = (function (_super) {
    __extends(ViewChangedEvent, _super);
    function ViewChangedEvent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ViewChangedEvent.prototype.trigger = function (id) {
        _super.prototype.fire.call(this, id);
    };
    return ViewChangedEvent;
}(liteEvent_1.LiteEvent));
var MainViewController = (function (_super) {
    __extends(MainViewController, _super);
    function MainViewController(root, mainLayout, mediumSet, columnSets, options) {
        var _this = _super.call(this) || this;
        _this._rowChangedEvent = new RowChangedEvent();
        _this._rowDeleteEvent = new RowChangedEvent();
        _this._rowAddEvent = new RowChangedEvent();
        _this._presetChangedEvent = new RowChangedEvent();
        _this._tableClearedEvent = new RowChangedEvent();
        _this._viewChangedEvent = new ViewChangedEvent();
        _this._statusChangedEvent = new ViewChangedEvent();
        _this._invalidateEvaluationEvent = new ViewChangedEvent();
        _this._options = options;
        _this.setMainLayout(mainLayout);
        var isOnlineApi = options.type === "top" || false;
        _this.setViewProviders(isOnlineApi);
        _this._mainLayout.generateTablePanel(root, MainViewController.calculateColumnWidth(mediumSet));
        _this.setGrids();
        _this.setGridCaptions();
        _this.setEditorProviders(options);
        _this.assignProvidersToGrids();
        _this.assignColumnSets(mediumSet, columnSets);
        _this.setAddBookingUnitsHandler(options.addBookingUnitsHandler);
        _this._planName = options.planName || "PlanName";
        _this.setScrollStateUpdatedHandlers();
        _this.registerGridObservers();
        _this.setBooleanClickHandling();
        _this.setMessageBoxes(options);
        _this.onViewSelected(0, options.planName);
        return _this;
    }
    MainViewController.calculateColumnWidth = function (columnSet) {
        var width = 0;
        columnSet.columns.forEach(function (col) {
            if (_.get(col, "settings.width")) {
                width += col.settings.width;
            }
        });
        return width;
    };
    Object.defineProperty(MainViewController.prototype, "status", {
        get: function () {
            return this._status;
        },
        enumerable: true,
        configurable: true
    });
    MainViewController.prototype.setStatusBusy = function () {
        if (this._status !== "busy") {
            this._statusChangedEvent.trigger("busy");
            this._status = "busy";
        }
    };
    MainViewController.prototype.setStatusIdle = function () {
        if (this._status !== "idle") {
            this._statusChangedEvent.trigger("idle");
            this._status = "idle";
        }
    };
    MainViewController.prototype.fireInvalidateEvaluationEvent = function () {
        this._invalidateEvaluationEvent.trigger("invalidateEvaluation");
    };
    MainViewController.prototype.setMainLayout = function (mainLayout) {
        var _this = this;
        this._mainLayout = mainLayout;
        this._mainLayout.setDeleteHandler(function (rows) { _this.deleteRows(rows); });
    };
    MainViewController.prototype.setViewProviders = function (isOnlineApi) {
        var font = this._mainLayout.getStandardFont();
        this._presetViewProvider = new CellViewProvider_1.viewsProviderClass(isOnlineApi, this._options);
        this._tableViewProvider = new CellViewProvider_1.viewsProviderClass(isOnlineApi, this._options);
        this._mediumViewProvider = new CellViewProvider_1.viewsProviderClass(isOnlineApi);
        this._totalViewProvider = new TotalRowViewProvider_1.totalRowViewProviderClass(isOnlineApi);
        this._presetViewProvider.setFont(font);
        this._tableViewProvider.setFont(font);
        this._totalViewProvider.setFont(font);
        this._mediumViewProvider.setFont(font);
        this._totalViewProvider["getCellColor"] = function (grid, row, col) {
            return configuration_1.PlanConfiguration.standardTableBackground;
        };
        this._tableViewProvider.standardFont = this._mainLayout.getStandardFont();
        this._tableViewProvider.boldFont = this._mainLayout.getStandardFont(true);
        this._presetViewProvider.standardFont = this._mainLayout.getStandardFont();
        this._presetViewProvider.boldFont = this._mainLayout.getStandardFont(true);
        this._mediumViewProvider.standardFont = this._mainLayout.getStandardFont();
        this._mediumViewProvider.boldFont = this._mainLayout.getStandardFont(true);
        this._totalViewProvider.standardFont = this._mainLayout.getStandardFont();
        this._totalViewProvider.boldFont = this._mainLayout.getStandardFont(true);
    };
    MainViewController.prototype.setGrids = function () {
        this._presetGrid = this._mainLayout.getPresetGrid();
        this._tableGrid = this._mainLayout.getTableGrid();
        this._mediumGrid = this._mainLayout.getMediumGrid();
        this._totalGrid = this._mainLayout.getTotalGrid();
    };
    MainViewController.prototype.setEditorProviders = function (options) {
        var _this = this;
        var font = this._mainLayout.getStandardFont();
        var smallFont = this._mainLayout.getSmallFont();
        this._presetEditorProvider = new CellEditorProvider_1.cellEditorProviderClass(font, smallFont, options);
        this._tableEditorProvider = new CellEditorProvider_1.cellEditorProviderClass(font, smallFont, options);
        this._mediumEditorProvider = new CellEditorProvider_1.cellEditorProviderClass(font, smallFont, options);
        this._mediumEditorProvider.addRowHandler = (function (row) { _this.addRow(row); });
        this._mediumEditorProvider.deleteRowHandler = (function (rows) { _this.deleteRows(rows); });
        this._tableEditorProvider.stopEditingOnAllGrids = this.stopEditingGrids.bind(this);
        this._presetEditorProvider.stopEditingOnAllGrids = this.stopEditingGrids.bind(this);
    };
    MainViewController.prototype.setGridCaptions = function () {
        var _this = this;
        this._tableGridCaption = this._mainLayout.getTableGridCaption();
        this._mediumGridCaption = this._mainLayout.getMediumGridCaption();
        this._tableGridCaption.bind("captionResized", function (baseCaption, index, previousWidth) {
            _this.onColumnResized(index);
        });
        this._mediumGridCaption.bind("captionResized", function (baseCaption, index, previousWidth) {
            _this.onMediumColumnResized(index);
        });
    };
    MainViewController.prototype.assignProvidersToGrids = function () {
        this._presetGrid.setViewProvider(this._presetViewProvider);
        this._presetGrid.setEditorProvider(this._presetEditorProvider);
        this._tableGrid.setViewProvider(this._tableViewProvider);
        this._tableGrid.setEditorProvider(this._tableEditorProvider);
        this._mediumGrid.setViewProvider(this._mediumViewProvider);
        this._mediumGrid.setEditorProvider(this._mediumEditorProvider);
        this._totalGrid.setViewProvider(this._totalViewProvider);
    };
    MainViewController.prototype.assignColumnSets = function (mediumSet, columnSets) {
        this._mediumColumnSet = mediumSet;
        this._columnSets = columnSets;
    };
    MainViewController.prototype.setAddBookingUnitsHandler = function (handler) {
        if (!handler) {
            handler = (function () {
                configuration_1.PlanConfiguration.logger.debug("Add booking units");
            });
        }
        this._addBookingUnitsHandler = handler;
    };
    MainViewController.prototype.setScrollStateUpdatedHandlers = function () {
        var _this = this;
        this._tableGrid.scrollManager.scrollStateUpdated = (function (x, y, px, py) {
            _this._mediumGrid.scrollManager.scrollYTo(y);
        });
        this._mediumGrid.scrollManager.scrollStateUpdated = (function (x, y, px, py) {
            _this._tableGrid.scrollManager.scrollYTo(y);
        });
        this._totalGrid.scrollManager.scrollStateUpdated = (function (x, y, px, py) {
            _this._presetGrid.scrollManager.scrollXTo(x);
            _this._tableGrid.scrollManager.scrollXTo(x);
        });
    };
    MainViewController.prototype.registerGridObservers = function () {
        this._tableGrid.registerObserver(this);
        this._mediumGrid.registerObserver(this);
    };
    MainViewController.prototype.setMessageBoxes = function (options) {
        this._messageBox = options.messageBox;
        this._onStartPopup = options.onStartPopup;
    };
    Object.defineProperty(MainViewController.prototype, "addBookingUnitsHandler", {
        set: function (handler) {
            this._addBookingUnitsHandler = handler;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainViewController.prototype, "addSingleBookingUnitsHandler", {
        set: function (handler) {
            this._addSingleBookingUnitsHandler = handler;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainViewController.prototype, "viewChangedEvent", {
        get: function () {
            return this._viewChangedEvent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainViewController.prototype, "statusChangedEvent", {
        get: function () {
            return this._statusChangedEvent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainViewController.prototype, "invalidateEvaluationEvent", {
        get: function () {
            return this._invalidateEvaluationEvent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainViewController.prototype, "activeMediumTypes", {
        set: function (types) {
            this._activeMediumTypes = types.map(function (type) { return type.toLowerCase(); });
            this.applyColumnSet(this.currentColumnSet, this._planName);
        },
        enumerable: true,
        configurable: true
    });
    MainViewController.prototype.assignTooltips = function (grid, rows) {
        grid.toolTipHandler.setColumnSet(this.currentColumnSet);
        grid.toolTipHandler.setRows(rows);
        grid.toolTipHandler.assignTooltip();
    };
    MainViewController.saveSettings = function (key, value) {
        Storage_1.StorageFactory.getStorage("planeditor").put(key, value);
    };
    MainViewController.loadSettings = function (key) {
        return Storage_1.StorageFactory.getStorage("planeditor").get(key);
    };
    MainViewController.prototype.setBooleanClickHandling = function () {
        this._tableGrid.addClickHandling((function (item) { return (typeof item === "boolean"); }), (function (item) { return !item; }));
        this._presetGrid.addClickHandling((function (item) { return (typeof item === "boolean"); }), (function (item) { return !item; }));
    };
    MainViewController.prototype.update = function (args) {
        var _this = this;
        this._tableGrid.setSelectedRows(args);
        this._mediumGrid.setSelectedRows(args);
        var selectedRows = [];
        args.forEach(function (index) {
            selectedRows.push(_this.rows[index]);
        });
        this._presetEditorProvider.rows = selectedRows;
    };
    Object.defineProperty(MainViewController.prototype, "rowChangedEvent", {
        get: function () {
            return this._rowChangedEvent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainViewController.prototype, "rowDeleteEvent", {
        get: function () {
            return this._rowDeleteEvent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainViewController.prototype, "rowAddEvent", {
        get: function () {
            return this._rowAddEvent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainViewController.prototype, "presetChangedEvent", {
        get: function () {
            return this._presetChangedEvent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainViewController.prototype, "tableClearedEvent", {
        get: function () {
            return this._tableClearedEvent;
        },
        enumerable: true,
        configurable: true
    });
    MainViewController.prototype.showMessageBox = function (message, title, stopEditingGrids, showCancelButton, showPopup) {
        var _this = this;
        if (showPopup === void 0) { showPopup = false; }
        if (message !== "" && showPopup === true) {
            return this._messageBox(function () {
                return new Promise(function (resolve, reject) {
                    if (stopEditingGrids) {
                        _this.stopEditingGrids(true);
                    }
                    resolve({ message: message, title: title });
                });
            }, showCancelButton);
        }
        else {
            return new Promise(function (resolve, reject) {
                if (message !== "") {
                    resolve({ accepted: true });
                }
                resolve(undefined);
            });
        }
    };
    MainViewController.prototype.stopEditingGrids = function (applyData) {
        if (applyData === void 0) { applyData = false; }
        this._tableGrid["stopEditing"](applyData);
        this._presetGrid["stopEditing"](applyData);
    };
    MainViewController.prototype.showStartPopup = function (data) {
        return this._onStartPopup(function () {
            return new Promise(function (resolve, reject) {
                resolve(data);
            });
        });
    };
    MainViewController.prototype.isPopup = function (field) {
        var columnSet = this.currentColumnSet.columns;
        var currentColumn = _.find(columnSet, function (column) {
            return (column.dataPath === field);
        });
        if (!currentColumn || !currentColumn.editor) {
            return false;
        }
        var editor = currentColumn.editor;
        return (editor.type !== planeditor_1.COLUMN_EDITORS.BUTTON &&
            editor.type !== planeditor_1.COLUMN_EDITORS.CHECKBOX &&
            editor.type !== planeditor_1.COLUMN_EDITORS.DROP_DOWN &&
            editor.type !== planeditor_1.COLUMN_EDITORS.TEXT_FIELD);
    };
    Object.defineProperty(MainViewController.prototype, "columnViews", {
        get: function () {
            var options = this._columnSets.map(function (option) { return option.name; });
            return options;
        },
        enumerable: true,
        configurable: true
    });
    MainViewController.prototype.onViewSelected = function (index, planName) {
        if (index !== this._currentViewIndex) {
            this._currentViewIndex = index;
            this.applyColumnSet(this._columnSets[index], planName);
            this.syncTableScrollPositions();
            this._viewChangedEvent.trigger(this._columnSets[index].key);
        }
    };
    MainViewController.prototype.onColumnResized = function (index) {
        var oldWidth = (_.get(this.currentColumnSet.columns[index], "settings.width"));
        var newWidth = this._tableGrid.getColWidth(index);
        if (oldWidth === 0) {
            this._tableGrid.setColWidth(index, 0);
            return;
        }
        this._presetGrid.setColWidth(index, newWidth);
        this._totalGrid.setColWidth(index, newWidth);
        MainViewController.saveSettings("table", this.getColumnSetSettings(this.currentColumnSet));
    };
    MainViewController.prototype.onMediumColumnResized = function (index) {
        MainViewController.saveSettings("medium", this.getColumnSetSettings(this._mediumColumnSet));
    };
    MainViewController.prototype.syncTableScrollPositions = function () {
        var tableGridX = this._tableGrid.scrollManager.getSX();
        this._presetGrid.scrollManager.scrollXTo(tableGridX);
        this._totalGrid.scrollManager.scrollXTo(tableGridX);
    };
    MainViewController.prototype.setEditors = function (defEditors, columnSet) {
        MainViewController.clearEditors(defEditors);
        columnSet.columns.forEach(function (column, index) {
            if (column.editor) {
                switch (column.editor.type) {
                    case planeditor_1.COLUMN_EDITORS.CHECKBOX:
                        defEditors.editors[index] = (new zebra.ui.grid.DefEditors.Checkbox(""));
                        break;
                    case planeditor_1.COLUMN_EDITORS.DROP_DOWN:
                        var combo = void 0;
                        var theList = void 0;
                        if (column.editor.config.display) {
                            theList = Object.keys(column.editor.config.display);
                        }
                        else {
                            theList = column.editor.config.list;
                        }
                        var theNewList = new zebra.ui.List(theList);
                        combo = new zebra.ui.grid.DefEditors.Combo(theNewList);
                        defEditors.editors[index] = combo;
                        break;
                    case planeditor_1.COLUMN_EDITORS.TEXT_FIELD:
                        var textFieldDefaultWidth = 150;
                        var textField = new zebra.ui.grid.DefEditors.TextField("", textFieldDefaultWidth);
                        defEditors.editors[index] = textField;
                        break;
                    case planeditor_1.COLUMN_EDITORS.AD_FORMAT:
                    case planeditor_1.COLUMN_EDITORS.TARGETING:
                    case planeditor_1.COLUMN_EDITORS.SPECIAL_PRICE:
                    case planeditor_1.COLUMN_EDITORS.BUTTON:
                    case planeditor_1.COLUMN_EDITORS.PERIOD:
                        break;
                    default:
                        throw new Error("Invalid column editor type " + column.editor.type);
                }
            }
            else {
                defEditors.editors[index] = undefined;
            }
        });
    };
    MainViewController.clearEditors = function (defEditors) {
        MainViewController.clearKeys(defEditors.editors);
    };
    MainViewController.clearKeys = function (object) {
        for (var key in object) {
            if (object.hasOwnProperty(key)) {
                delete object[key];
            }
        }
    };
    MainViewController.prototype.updateTableModel = function (columnSet, rows) {
        this.updateTable(this._tableGrid, columnSet, rows, this.onTableCellModified.bind(this));
    };
    MainViewController.prototype.updateMediumModel = function (columnSet, rows) {
        this.updateTable(this._mediumGrid, columnSet, rows, this.onTableCellModified.bind(this));
    };
    MainViewController.prototype.updatePresetModel = function (columnSet, tableRow) {
        this.updateTable(this._presetGrid, columnSet, [tableRow], this.onPresetCellModified.bind(this), true);
    };
    MainViewController.prototype.updateTotalModel = function (columnSet, tableRow) {
        this.updateTable(this._totalGrid, columnSet, [tableRow]);
    };
    MainViewController.prototype.updateTable = function (grid, columnSet, rows, cellModifiedHandler, useAlwaysUpdateMatrix) {
        if (useAlwaysUpdateMatrix === void 0) { useAlwaysUpdateMatrix = false; }
        var model = MainViewController.createTableMatrix(columnSet, rows, useAlwaysUpdateMatrix);
        if (cellModifiedHandler) {
            model.bind("cellModified", function (matrix, row, col, previous) {
                cellModifiedHandler(matrix, row, col);
            });
        }
        grid.setModel(model);
        grid.setRowsHeight(configuration_1.PlanConfiguration.rowHeight);
        var theSelectedRow = 0;
        if (grid.getLastSelectedRow) {
            theSelectedRow = grid.getLastSelectedRow();
        }
        grid.select(theSelectedRow);
    };
    MainViewController.createTableMatrix = function (columnSet, rows, useAlwaysUpdateMatrix) {
        rows = rows || [];
        var matrix = useAlwaysUpdateMatrix ? new alwaysUpdateMatrix_1.alwaysUpdateMatrix() : new zebra.data.Matrix();
        matrix.setCols(columnSet.columns.length);
        matrix.setRows(rows.length);
        MainViewController.fillTableMatrix(matrix, columnSet, rows);
        return matrix;
    };
    MainViewController.fillTableMatrix = function (matrix, columnSet, rows) {
        rows.forEach(function (row, rowIndex) {
            columnSet.columns.forEach(function (column, colIndex) {
                var value = _.get(row, column.dataPath);
                if (column.dataType === planeditor_1.DATA_TYPES.BOOLEAN && !value) {
                    value = false;
                }
                matrix.put(rowIndex, colIndex, value);
            });
        });
    };
    MainViewController.prototype.addRow = function (index) {
        var rowToAdd = this._rows[index];
        rowToAdd.isCleared = false;
        this._tableGrid.repaint();
        this._rowAddEvent.trigger(rowToAdd);
        this._tableGrid.repaint();
    };
    MainViewController.prototype.deleteRows = function (indices) {
        var _this = this;
        var rowsToDelete = [];
        indices.forEach(function (index) {
            _this._rows[index].isCleared = true;
            rowsToDelete.push(_this._rows[index]);
            _this._tableGrid.removeFromSelectedRows(index);
        });
        this._rowDeleteEvent.trigger(rowsToDelete);
    };
    MainViewController.prototype.onTableCellModified = function (matrix, row, col) {
        var rowData = this._rows[row];
        var field = this.currentColumnSet.columns[col].dataPath;
        this._rowChangedEvent.trigger(rowData, field, matrix.get(row, col), row);
        this._tableGrid.select(row, true);
        this._mediumGrid.select(row, true);
    };
    MainViewController.prototype.onPresetCellModified = function (matrix, row, col) {
        var rowData = this._presetRow;
        var field = this.currentColumnSet.columns[col].dataPath;
        this._presetChangedEvent.trigger(rowData, field, matrix.get(row, col), row);
    };
    MainViewController.prototype.getSelectedRows = function () {
        return this._tableGrid.getSelectedRows();
    };
    MainViewController.prototype.setSplittedPanels = function (panel, columnCaption) {
        var _this = this;
        var splitted = columnCaption.split("\n");
        splitted.forEach(function (line) {
            var label = new zebra.ui.Label(line);
            label.setFont(_this._mainLayout.getSmallFont());
            label.setColor(configuration_1.PlanConfiguration.tableHeadColor);
            panel.add(label);
        });
    };
    MainViewController.prototype.generateMediumGridHeader = function (panel, planName) {
        var _this = this;
        var buttonPanel = new zebra.ui.Panel(new zebra.layout.FlowLayout(zebra.layout.CENTER, zebra.layout.CENTER, zebra.layout.VERTICAL));
        var buttonText = new zebra.ui.Label(this._options.buttonCaption || "BUTTON");
        buttonText.setFont(this._mainLayout.getSmallFont());
        buttonText.setColor(configuration_1.PlanConfiguration.buttonText);
        var button = new zebra.ui.Button(buttonText);
        button.setPadding(configuration_1.PlanConfiguration.buttonPadding);
        button.setBackground(configuration_1.PlanConfiguration.buttonBackground);
        button.setBorder(this._mainLayout.getBorder(configuration_1.PlanConfiguration.borderWidth));
        button.bind(function (src) {
            _this._addBookingUnitsHandler();
        });
        var buttonBar = new zebra.ui.Panel(new zebra.layout.FlowLayout(zebra.layout.CENTER, zebra.layout.CENTER, zebra.layout.HORIZONTAL));
        if (this._options.type === "stroer" && this._posterController) {
            var comboValues = this._posterController.products.map(function (product) { return product + " (einzeln)"; });
            comboValues.unshift("Mehrere Produkte");
            comboValues.unshift(" - Produkt hinzufügen - ");
            this._productCombo = this.createCombo(comboValues);
            buttonBar.add(this._productCombo);
        }
        else {
            buttonBar.add(button);
        }
        var label = new zebra.ui.Label(planName);
        label.setFont(this._mainLayout.getBigFont(true));
        label.setColor(configuration_1.PlanConfiguration.tableHeadColor);
        buttonPanel.add(buttonBar);
        panel.add(buttonPanel);
    };
    MainViewController.prototype.createCombo = function (data) {
        var combo = new zebra.ui.Combo(data);
        this.formatCombo(combo);
        return combo;
    };
    MainViewController.prototype.formatCombo = function (combo) {
        var _this = this;
        combo.setBackground(configuration_1.PlanConfiguration.comboBackground);
        combo.setBorder(this._mainLayout.getBorder(configuration_1.PlanConfiguration.borderWidth));
        combo.list["provider"]["text"]["font"] = this._mainLayout.getStandardFont();
        combo.list["provider"]["text"]["color"] = configuration_1.PlanConfiguration.textColor;
        combo.select(0);
        if (this._options.type === "stroer") {
            combo.bind(function (theCombo, value) {
                var selectedIndex = theCombo.list.selectedIndex;
                switch (selectedIndex) {
                    case 0: break;
                    case 1:
                        _this._addBookingUnitsHandler();
                        break;
                    default:
                        _this._addSingleBookingUnitsHandler();
                }
            });
        }
    };
    MainViewController.prototype.getPosterComboValues = function () {
        var selected = this._productCombo.list.getSelected();
        if (_.endsWith(selected, " (einzeln)")) {
            selected = selected.replace(" (einzeln)", "");
        }
        var product = this._posterController.getProductKey(selected);
        var hourIndex = 0;
        var weekDayIndex = 0;
        var spotLengthIndex = 2;
        var regionIndex = 0;
        var mediumKey = "SSTR" + product;
        [hourIndex, weekDayIndex, spotLengthIndex, regionIndex].forEach(function (index) {
            mediumKey += "_" + (index + 1);
        });
        var longTitle = this._posterController.getProductTitleByKey(product);
        return { key: mediumKey, longTitle: longTitle };
    };
    MainViewController.prototype.renamePlan = function (newName) {
        this._planName = newName;
        this.setTableCaptions(this._mediumGridCaption, this._mediumColumnSet, newName);
    };
    MainViewController.prototype.setTableCaptions = function (gridCaption, columnSet, planName) {
        var _this = this;
        MainViewController.pickColumns(columnSet).forEach(function (column, index) {
            var columnCaption = column.caption;
            var panel = new zebra.ui.Panel(new zebra.layout.FlowLayout(zebra.layout.CENTER, zebra.layout.CENTER, zebra.layout.VERTICAL));
            panel.setBackground(configuration_1.PlanConfiguration.gridHeaderBackground);
            if (column.isGroupColumn) {
                _this.generateMediumGridHeader(panel, planName);
            }
            else {
                _this.setSplittedPanels(panel, columnCaption);
            }
            panel.setPreferredSize(-1, configuration_1.PlanConfiguration.tableHeadHeight);
            gridCaption.putTitle(index, panel);
        });
    };
    MainViewController.pickColumns = function (columnSet) {
        return columnSet.columns.map(function (column) { return column; });
    };
    MainViewController.prototype.applyColumnSet = function (columnSet, planName) {
        this.filterColumnSetByType(columnSet);
        this._presetEditorProvider.setColumnSet(columnSet);
        this._tableEditorProvider.setColumnSet(columnSet);
        this._presetViewProvider.setColumnSet(columnSet);
        this._tableViewProvider.setColumnSet(columnSet);
        this._totalViewProvider.setColumnSet(columnSet);
        this._mediumViewProvider.setColumnSet(this._mediumColumnSet);
        this._mediumEditorProvider.setColumnSet(this._mediumColumnSet);
        this.updatePresetModel(columnSet, this._presetRow);
        this.updateTableModel(columnSet, this._rows);
        this.updateMediumModel(this._mediumColumnSet, this._rows);
        this.updateTotalModel(columnSet, this._totalRow);
        this.setTableCaptions(this._tableGridCaption, columnSet);
        this.setTableCaptions(this._mediumGridCaption, this._mediumColumnSet, planName);
        this.setEditors(this._tableEditorProvider, columnSet);
        this.setEditors(this._mediumEditorProvider, this._mediumColumnSet);
        var settings = MainViewController.loadSettings("table");
        this.applyColumnSetSettings(columnSet, [this._presetGrid, this._tableGrid, this._totalGrid], settings);
        var mediumSettings = MainViewController.loadSettings("medium");
        this.applyColumnSetSettings(this._mediumColumnSet, [this._mediumGrid], mediumSettings);
    };
    MainViewController.prototype.filterColumnSetByType = function (columnSet) {
        var _this = this;
        var newColumns = columnSet.columns.filter(function (column) {
            return _this.isColumnTypeInActiveMediumTypes(column.types);
        });
        columnSet.columns = newColumns;
    };
    MainViewController.prototype.isColumnTypeInActiveMediumTypes = function (columnTypes) {
        if (!columnTypes || !this._activeMediumTypes) {
            return true;
        }
        return _.intersection(columnTypes, this._activeMediumTypes).length > 0;
    };
    MainViewController.prototype.applyColumnSetSettings = function (source, target, settings) {
        var _this = this;
        settings = settings || { columns: {} };
        var overrideColumns = settings.columns;
        source.columns.forEach(function (column, index) {
            _this.applyColumnSettings(target, index, _.extend(column.settings || {}, overrideColumns[column.key]));
        });
    };
    MainViewController.prototype.applyColumnSettings = function (target, index, settings) {
        var colWidth = settings.width !== undefined ? settings.width : configuration_1.PlanConfiguration.tableDefaultWidth;
        target
            .forEach(function (grid) {
            grid.setColWidth(index, colWidth);
        });
    };
    MainViewController.prototype.getColumnSetSettings = function (columnSet) {
        var _this = this;
        var columnSettings = {};
        columnSet.columns.forEach(function (column, index) {
            columnSettings[column.key] = { width: _this._tableGrid.getColWidth(index) };
        });
        return { columns: columnSettings };
    };
    MainViewController.prototype.setCheckboxState = function (rows, conditionPath, checkboxPath) {
        var _this = this;
        var currentColumnSet = this.currentColumnSet.columns;
        var currentColumnIndex = _.findIndex(currentColumnSet, function (candidate) { return candidate.dataPath === conditionPath; });
        if (currentColumnIndex === -1) {
            return;
        }
        rows.forEach(function (row, index) {
            var value = _.get(row, conditionPath);
            var valueUndefined = value !== undefined && value !== configuration_1.PlanConfiguration.ERROR_STRING;
            _this._tableViewProvider.setCheckboxEnabled(_this._tableGrid, index, checkboxPath, valueUndefined);
            _this._tableEditorProvider.setCheckboxEnabled(_this._tableGrid, index, checkboxPath, valueUndefined);
        });
    };
    Object.defineProperty(MainViewController.prototype, "currentColumnSet", {
        get: function () {
            return this._columnSets[this._currentViewIndex];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainViewController.prototype, "allColumns", {
        get: function () {
            var result = [];
            this._columnSets.map(function (item) {
                result = result.concat(item.columns);
            });
            return _.uniq(result);
        },
        enumerable: true,
        configurable: true
    });
    MainViewController.prototype.getTableViewProvider = function () {
        return this._tableViewProvider;
    };
    Object.defineProperty(MainViewController.prototype, "rows", {
        get: function () {
            return this._rows;
        },
        set: function (rows) {
            var _this = this;
            this._rows = rows;
            this.updateTableModel(this.currentColumnSet, rows);
            this.updateMediumModel(this._mediumColumnSet, rows);
            this._tableEditorProvider.setReadOnlyMask(rows.map(function (row) { return row.isReadOnly; }));
            this._tableViewProvider.rows = rows;
            this._tableEditorProvider.rows = rows;
            var selRows = [];
            this.getSelectedRows().forEach(function (index) {
                selRows.push(_this.rows[index]);
            });
            this._presetEditorProvider.rows = selRows;
            this._mediumViewProvider.rows = rows;
            this.assignTooltips(this._tableGrid, this._rows);
            this._mediumGrid["rows"] = this._rows;
            this._tableGrid["rows"] = this._rows;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainViewController.prototype, "presetRow", {
        get: function () {
            return this._presetRow;
        },
        set: function (row) {
            this._presetRow = row;
            this.updatePresetModel(this.currentColumnSet, row);
            this._presetViewProvider.rows = [row];
            this.assignTooltips(this._presetGrid, [this._presetRow]);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainViewController.prototype, "totalRow", {
        get: function () {
            return this._totalRow || {};
        },
        set: function (row) {
            this._totalRow = row;
            this.updateTotalModel(this.currentColumnSet, row);
            this._totalViewProvider.rows = [row];
        },
        enumerable: true,
        configurable: true
    });
    MainViewController.prototype.clearAllSelectedRows = function () {
        this._tableGrid.clearAllSelectedRows();
    };
    Object.defineProperty(MainViewController.prototype, "planName", {
        get: function () {
            return this._planName;
        },
        enumerable: true,
        configurable: true
    });
    MainViewController.prototype.scrollToBottom = function () {
        this._mainLayout.scrollToBottom();
    };
    MainViewController.prototype.addDropDownHandler = function (handler) {
        var columns = this._columnSets.map(function (item) {
            return item.columns;
        });
        columns.forEach(function (columnSet) {
            columnSet.forEach(function (column) {
                if (column.key === handler.key) {
                    _.set(column, "editor.getValues", handler.getDropDownValues());
                    _.set(column, "editor.addValue", handler.addDropDownValue());
                }
            });
        });
    };
    MainViewController.prototype.getViewComboSelectedIndex = function () {
        return 0;
    };
    MainViewController.prototype.setPosterData = function (posterData, stationData) {
        this._posterController = new posterController_1.PosterController(posterData, stationData);
        this.setTableCaptions(this._mediumGridCaption, this._mediumColumnSet, this._planName);
        this._presetEditorProvider.setPosterController(this._posterController);
        this._tableEditorProvider.setPosterController(this._posterController);
    };
    Object.defineProperty(MainViewController.prototype, "limitValue", {
        get: function () {
            return this._limitValue;
        },
        set: function (value) {
            this._tableViewProvider.setLimitValue(value);
            this._totalViewProvider.setLimitValue(value);
            this._limitValue = value;
        },
        enumerable: true,
        configurable: true
    });
    return MainViewController;
}(AbstractTableController_1.AbstractTableController));
exports.MainViewController = MainViewController;
//# sourceMappingURL=mainViewController.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/mainViewController.js
// module id = 13
// module chunks = 0